import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';

const TwBaseCard = styled(Card)(({ theme }) => ({
  boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);',
  background: '#FFFFFF',
  borderRadius: '4px'
}));

export default TwBaseCard;
